module.exports = __webpack_public_path__ + "img/p6.fee6201f.png";